import React,{useState} from "react";
import { Button } from "react-bootstrap";
import PartnerNavbar from "./PartnerNavbar";
import PartnerLanding from "./PartnerLanding";
import JoinPantnerCore from "./JoinPantnerCore";
import Experience from "../Experience/Experience";
import Question from "../Question/Question";
import Footer from "../Footer/Footer";
import Expert from "../Expert/Expert";
import PartnerForm from "./PartnerForm";
import BottomNavbar from "../BottomNavbar/BottomNavbar";
import { FaThumbsUp, FaThumbsDown ,FaBars} from "react-icons/fa";
export default function PartnerHome() {
    const [feedback, setFeedback] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [tocOpen, setTocOpen] = useState(false);
  
    const handleFeedback = (type) => {
      setFeedback(type);
      setSubmitted(true);
      // TODO: send to backend API if needed
    };
  return (
    <>
      <PartnerLanding />
      <JoinPantnerCore />
      <Experience />
      <PartnerForm />
      <Expert />
      <Question />
      <div className="mt-4 p-3 border-top">
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{textAlign:"center"}}>Was this information helpful?</p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}
              >
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{textAlign:"center"}}>Thank you for your feedback! 🙏</p>
        )}
      </div>
      <br/>
      <Footer />
      <BottomNavbar />
    </>
  );
}
